import { flow, map, take } from 'lodash/fp';

import getImageAttributes from '../../../../../cms/utils/get-image-attributes';
import type { ImageObject, Maybe, UrlObject } from '../../../../../types/__codegen__/sanity/graphql';

type ValuePropositionTileInput = {
  name?: Maybe<string>;
  imageObject?: Maybe<ImageObject>;
  summary?: unknown;
  urlObject?: Maybe<UrlObject>;
};

const getValuePropositionData = flow(
  take(3),
  map(({ name: title, imageObject, summary, urlObject }: ValuePropositionTileInput) => ({
    image: getImageAttributes({ imageObject }),
    summary,
    title,
    urlObject,
  })),
);

export default getValuePropositionData;
